import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { validationmethod } from 'src/app/shared/models/validationmethod';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { constants } from 'src/app/shared/common/contants';
export interface createHeaderPopupEditData {
  headerList: any; 
  editData:any;
}
@Component({
    selector: 'app-create-header-popup',
    templateUrl: './create-header-popup.component.html',
    styleUrls: ['./create-header-popup.component.scss'],
    standalone: false
})
export class CreateHeaderPopupComponent implements OnInit {

  validations_form: UntypedFormGroup;
  target_header_validations_form: UntypedFormGroup; 
  validation_messages
  headersObjects={
    "index":null,
    "sourceOrTarget":"",
    "label":"",
    "datatype":"",
    "keyOrder":"",
    "isMandatory":false
  }

  sourceOrTargetTypeData=[
    {
      type:"Source"
    },
    {
      type:"Target"
    }
  ]
 
  headersDataList=[]
  datatypeList=["String","Integer","Boolean"]
  buttonColor = "";
  backgroundColorScreen;
  editHeadersListData=[]
  targetHeaderList=[]
  showTargetFieldOnly=false
  constructor(private validation: validationmethod,
    private localStorageSettings: LocalStorageSettingsService,
    public dialogref: MatDialogRef<CreateHeaderPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data:createHeaderPopupEditData,
    private snackbar: MatSnackBar,
     private msg: ErrorMessages,
     private constants: constants  
  ) { 
    this.validation_messages = this.msg.valueMapping;
  }

  ngOnInit(): void {
    this.editHeadersListData=this.data.headerList;
    console.log(this.editHeadersListData);
    if(this.editHeadersListData && this.editHeadersListData.length > 0){
      this.showTargetFieldOnly=true
    }

    if(this.data.editData){
      this.headersDataList= JSON.parse(JSON.stringify(this.data.editData));
      for(let i=0;i<this.headersDataList.length;i++){
        this.headersDataList[i].index=i
      }
    }
    console.log(this.headersDataList);
    
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");
    this.formValidation();
  }
formValidation() {
    
    this.validations_form = new UntypedFormGroup({

      headerName: new UntypedFormControl('', [Validators.required,Validators.maxLength(100)]),
      sourceOrTarget:new UntypedFormControl('', [Validators.required]),
      dataType:new UntypedFormControl('', [Validators.required]),
      keyOrder:new UntypedFormControl('', [Validators.required]),
      isMandatory:new UntypedFormControl('')
    });
    this.target_header_validations_form= new UntypedFormGroup({
      targetHeaderList:new UntypedFormControl('', [Validators.required])
    });
    
  }

  onSourceOrTarget(event){

  }
  addWhere(){
   
    if (!this.validations_form.valid) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.validations_form);

      this.validation.getvalidationmessage();

    } else {
      let checkDublicateKeyOrder = this.headersDataList.filter(header=>header.keyOrder == this.headersObjects.keyOrder)
      console.log(checkDublicateKeyOrder);
      
      // && header.sourceOrTarget == this.headersObjects.sourceOrTarget
     
      if(this.headersObjects.index == null){
        if(checkDublicateKeyOrder.length == 0){

          const newLabel = this.normalizeLabel(this.headersObjects.label);

//  Prevent default headers (case-insensitive)
const defaultHeaders = this.constants.CODELIST_MANDATORY_HEADERS
  .map(h => this.normalizeLabel(h.label));

if (defaultHeaders.includes(newLabel)) {
  this.snackbar.open("This header already exists and cannot be added.", "OK", {
    duration: 5000,
  });
  return;
}



          console.log(this.headersObjects);
          this.headersObjects.index=this.headersDataList.length
          this.headersDataList.push(this.headersObjects);
          this.headersObjects={
            "index":null,
            "sourceOrTarget":"",
            "label":"",
            "datatype":"",
            "keyOrder":"",
            "isMandatory":false
          }
          console.log(this.headersDataList);
          
          this.validations_form.reset();
          this.formValidation();
          this.validations_form.clearValidators();
        }else{
          this.snackbar.open("Key Order value must be unique", "OK", {
            duration: 5000,
          });
        }
      }else{
        if(checkDublicateKeyOrder.length == 0){
          this.headersDataList[this.headersObjects.index]=this.headersObjects
          this.headersObjects={
            "index":null,
            "sourceOrTarget":"",
            "label":"",
            "datatype":"",
            "keyOrder":"",
            "isMandatory":false
          }
          console.log(this.headersDataList);
          
          this.validations_form.reset();
          this.formValidation();
          this.validations_form.clearValidators();
        }else{
          if(checkDublicateKeyOrder[0].index == this.headersObjects.index){
            this.headersDataList[this.headersObjects.index]=this.headersObjects
            this.headersObjects={
              "index":null,
              "sourceOrTarget":"",
              "label":"",
              "datatype":"",
              "keyOrder":"",
              "isMandatory":false
            }
            console.log(this.headersDataList);
            
            this.validations_form.reset();
            this.formValidation();
            this.validations_form.clearValidators();
          }else{
            this.snackbar.open("Key Order value must be unique", "OK", {
              duration: 5000,
            });
          }
          
        }
      }
     
     
    }
  }

  deleteWhere(k) {
    console.log(k)
    this.headersDataList.splice(k, 1);
  }
  cancel(){
    console.log("***********************");
    
    this.dialogref.close();
  }
  saveHeaders(){
    if(this.headersDataList.length > 0){
      this.dialogref.close(this.headersDataList);
    }
    
  }
  saveEditHeaders(){
    if (!this.target_header_validations_form.valid) {
      this.validation.validateAllFormFields(this.target_header_validations_form);

      this.validation.getvalidationmessage();
    }else{
      for(let i=0;i<this.editHeadersListData.length;i++){
        let checkHeader = this.headersDataList.filter(header=>header.label == this.editHeadersListData[i])
        console.log(checkHeader);
        
        if(checkHeader.length == 0){
          let headerObj={
            "sourceOrTarget":"Source",
            "label":this.editHeadersListData[i],
            "datatype":"String",
          }
          this.headersDataList.push(headerObj);
        }
      }
      console.log(this.headersDataList);
      
      if(this.headersDataList.length > 0){
        this.dialogref.close(this.headersDataList);
      }
    }
  }
  selectedTargetList(event){
    this.headersDataList=[]
    console.log(this.targetHeaderList);
    for(let i=0;i<this.targetHeaderList.length;i++){
      let headerObj={
        "sourceOrTarget":"Target",
        "label":this.targetHeaderList[i],
        "datatype":"String",
      }
      this.headersDataList.push(headerObj);
    }
  }

  editHeader(event,index){
    if (this.isDefaultHeader(event.label)) {
    return;
  }
    console.log(index);
    
    console.log(event);
    this.headersObjects.index = index;
    this.headersObjects.sourceOrTarget=event.sourceOrTarget
    this.headersObjects.label=event.label
    this.headersObjects.datatype=event.datatype
    this.headersObjects.keyOrder=event.keyOrder
    this.headersObjects.isMandatory= event.isMandatory ?? false
  }

  //  /**
  //  * @Author DARSHAN NAGARAJ
  //  * @Date 05-05-2026
  //  * @Desc Checks if a given label matches any mandatory headers using case-insensitive comparison.Used to disable the edit option.*/
isDefaultHeader(label: string): boolean {

  const defaultHeaders = this.constants.CODELIST_MANDATORY_HEADERS
    .map(h => this.normalizeLabel(h.label));

  return defaultHeaders.includes(this.normalizeLabel(label));
}
normalizeLabel(label: string): string {
  return label?.trim().toLowerCase();
}
}
